import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Page from "../molecules/Page";

const apiUrl = process.env.REACT_APP_API_SOURCE;

const PasswordResetConfirm = () => {
  // --- LOGIKA KOMPONENTU POZOSTAJE BEZ ZMIAN ---
  const location = useLocation();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [passwordHints, setPasswordHints] = useState([]);
  
  // Usunięto stany showPassword i showConfirmPassword
  
  const token = new URLSearchParams(location.search).get("token");

  const validatePassword = (value) => {
    const hints = [];
    if (value.length < 8) {
      hints.push("Hasło musi mieć co najmniej 8 znaków.");
    }
    if (!/[A-Z]/.test(value)) {
      hints.push("Hasło musi zawierać co najmniej jedną wielką literę.");
    }
    if (!/[a-z]/.test(value)) {
      hints.push("Hasło musi zawierać co najmniej jedną małą literę.");
    }
    if (!/[0-9!@#$%^&*(),.?":{}|<>]/.test(value)) {
      hints.push("Hasło musi zawierać co najmniej jedną cyfrę lub znak specjalny.");
    }
    setPasswordHints(hints);
    return hints.length === 0;
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    validatePassword(newPassword);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (password !== confirmPassword) {
      setError("Hasła muszą być takie same.");
      return;
    }
    if (!validatePassword(password)) {
      return;
    }
    setIsSubmitting(true);

    try {
      const response = await fetch(`${apiUrl}password_reset/confirm/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: password, token: token }),
      });

      if (response.ok) {
        setMessage("Hasło zostało pomyślnie zresetowane.");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        const errorData = await response.json();
        setError(errorData?.message || "Wystąpił błąd. Spróbuj ponownie.");
      }
    } catch (err) {
      setError("Błąd połączenia. Sprawdź swoje połączenie i spróbuj ponownie.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Page showNav={false}>
      <div className="flex flex-col max-w-2xl mx-auto w-full flex-grow px-4 lg:px-0">
        <div className="bg-white rounded-xl lg:rounded-[3rem] shadow-[4px_4px_12px_rgba(0,0,0,0.35)] border border-gray-200 py-8 px-6 lg:px-14 w-full space-y-6 mt-[3vh] lg:mt-[8vh]">
          
          <h2 className="text-center text-xl font-apotek uppercase tracking-widest font-semibold text-[#233855]">
            Ustaw nowe hasło
          </h2>

          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* Nowe hasło */}
            <div>
              <label htmlFor="password" className="block text-[0.8rem] font-apotek uppercase tracking-widest font-semibold text-[#233855] mb-2">
                Nowe hasło
              </label>
              <input
                type="password"
                id="password"
                required
                value={password}
                onChange={handlePasswordChange}
                className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-base text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-[#233855] focus:ring-1 focus:ring-[#233855] sm:text-sm/6"
              />
              {passwordHints.length > 0 && (
                <ul className="mt-2 ml-5 text-xs list-disc text-gray-600">
                  {passwordHints.map((hint, index) => (
                    <li key={index}>{hint}</li>
                  ))}
                </ul>
              )}
            </div>

            {/* Potwierdź hasło */}
            <div>
              <label htmlFor="confirm-password" className="block text-[0.8rem] font-apotek uppercase tracking-widest font-semibold text-[#233855] mb-2">
                Potwierdź nowe hasło
              </label>
              <input
                type="password"
                id="confirm-password"
                required
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-base text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-[#233855] focus:ring-1 focus:ring-[#233855] sm:text-sm/6"
              />
            </div>

            {/* Przycisk zmiany hasła */}
            <div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="flex w-full justify-center rounded-lg bg-[#233855] px-3 py-2 text-sm font-apotek uppercase tracking-widest text-slate-100 shadow-lg hover:bg-[#345081] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#233855] disabled:bg-slate-400 disabled:cursor-wait"
              >
                {isSubmitting ? "Zmieniam..." : "Zmień hasło"}
              </button>
            </div>
          </form>

          {/* Komunikaty */}
          <div className="text-center">
             {message && <p className="text-sm text-green-600 mt-4">{message}</p>}
             {error && <p className="text-sm text-red-600 mt-4">{error}</p>}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default PasswordResetConfirm;